<template>
  <v-navigation-drawer v-model="toggler" app clipped :width="300">
    <v-list dense>
      <v-subheader>Tableros principales</v-subheader>
      <div v-if="auth.getProject().name == 'DAVIVIENDA II'">
      <v-list-item 
        v-for="item in itemsD2"
        :key="item.id"
        link
        :to="item.path"
      >
        <v-list-item-action>
          <v-icon>{{item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{item.name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
        </div>

      <v-list-item
        link
        to="/smartchronos/dashboard2"
        v-if="auth.getProject().name == 'DAVIVIENDA' || auth.getProject().name == 'MAKRO' || auth.getProject().name == 'DEMO'"
      >
        <v-list-item-action>
          <v-icon>mdi-flash</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{auth.getProject().name == 'MAKRO' ? "Energía general" : "Energía"}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        to="/smartchronos/dashboard10"
        v-if="auth.getProject().name == 'MAKRO' || auth.getProject().name == 'DEMO'"
      >
        <v-list-item-action>
          <v-icon>mdi-flash</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Energía indicadores</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        to="/smartchronos/dashboard11"
        v-if="auth.getProject().name == 'MAKRO' || auth.getProject().name == 'DEMO'"
      >
        <v-list-item-action>
          <v-icon>mdi-flash</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Energía por punto</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        to="/smartchronos/dashboardagua"
        v-if="auth.getProject().name == 'DAVIVIENDA'"
      >
        <v-list-item-action>
          <v-icon>mdi-water</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Agua</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        to="/smartchronos/dashboard2"
        v-if="auth.getProject().name == 'DOLLARCITY'"
      >
        <v-list-item-action>
          <v-icon>mdi-flash</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>ETAPA I</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        to="/smartchronos/dashboardagua"
        v-if="auth.getProject().name == 'DOLLARCITY'"
      >
        <v-list-item-action>
          <v-icon>mdi-flash</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>ETAPA II</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        to="/smartchronos/dashboard2"
        v-if="auth.getProject().name == 'EAAV ESP'"
      >
        <v-list-item-action>
          <v-icon>mdi-flash</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-subheader v-if="auth.getProject().name != 'EAAV ESP'"
        >MÓDULOS</v-subheader
      >
      <!-- <v-list-item
        link
        to="/smartchronos/facturacion"
        v-if="(modules && modules.includes('FACTURACION')) || auth.isVertebra()"
      >
        <v-list-item-action>
          <v-icon>mdi-file-chart-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Facturación</v-list-item-title>
        </v-list-item-content>
      </v-list-item>-->
      <!-- <v-list-item
        link
        to="/smartchronos/habitos-consumo"
        v-if="(modules && modules.includes('HABITOS')) || auth.isVertebra()"
      >
        <v-list-item-action>
          <v-icon>mdi-chart-arc</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Hábitos de consumo</v-list-item-title>
        </v-list-item-content>
      </v-list-item>  -->

      <v-list-group
        prepend-icon="mdi-chevron-down"
        append-icon
        v-if="items.length > 0"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Facturación</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          dense
          v-for="(item, index) in items"
          :key="index"
          link
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group prepend-icon="mdi-chevron-down" append-icon  v-if="itemsH.length > 0">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{
              auth.getProject().name != "EAAV ESP"
                ? "Habitos de consumo"
                : "Medida parcial"
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          dense
          v-for="(item, index) in itemsH"
          :key="index"
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- <v-list-item
        link
        to="/smartchronos/real-time"
        v-if="(modules && modules.includes('REALTIME')) || auth.isVertebra()"
      >
        <v-list-item-action>
          <v-icon>alarm</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Tiempo real</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <v-divider></v-divider>
      <v-list-item
        link
        to="/smartchronos/dcreator"
        v-if="false && auth.isVertebra()"
      >
        <v-list-item-action>
          <v-icon>mdi-monitor-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>D-Creator</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        to="/smartchronos/ajustes"
        v-if="['ADMIN'].includes(auth.getRol()) || auth.isVertebra()"
      >
        <v-list-item-action>
          <v-icon>mdi-wrench</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Ajustes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        to="/smartchronos/administracion"
        v-if="auth.isSuperadmin()"
      >
        <v-list-item-action>
          <v-icon>settings</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Administración</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item link to="/smartchronos/alertas" v-if="auth.isSuperadmin()">
        <v-list-item-action>
          <v-icon>info</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Alertas</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-badge
            color="primary"
            :content="this.alertsNum"
            v-if="this.alertsNum > 0"
            inline
          ></v-badge>
        </v-list-item-action>
      </v-list-item> -->
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
import axios from "axios";
import { apiv1 } from "../../../libs/apiv1";

export default Vue.extend({
  name: "Sidebar",
  props: ["drawer"],
  computed: {
    toggler: {
      get: function () {
        return this.drawer;
      },
      set: function (value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  async mounted() {
    this.getdashboards(this.auth.getProject().name);
    this.getproyect();
    await this.getAlerts();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setAlertsNum") {
        this.alertsNum = state.alertsNum;
      }
    });
  },
  data() {
    return {
      itemsD2: [
        {
        id: 1,
        path:"/smartchronos/dashboard2",
        name: "Consumo general",
        icon: "mdi-view-dashboard"
      },
      {
        id: 2,
        path:"/smartchronos/dashboard4",
        name: "Consumo por sucursal",
        icon: "mdi-view-dashboard"
      },
      {
        id: 3,
        path:"/smartchronos/dashboard5",
        name: "comparación general",
        icon: "mdi-view-dashboard"
      },
     /* {
        id: 4,
        path:"/smartchronos/dashboard6",
        name: "comparación por sucursal",
        icon: "mdi-view-dashboard"
      },*/
      {
        id: 5,
        path:"/smartchronos/dashboard7",
        name: "Consumo medidores general",
        icon: "mdi-view-dashboard"
      },
      {
        id: 6,
        path:"/smartchronos/dashboard8",
        name: "Consumo medidores sucursal",
        icon: "mdi-view-dashboard"
      },
      {
        id: 7,
        path:"/smartchronos/dashboard9",
        name: "Consumo medidores punto",
        icon: "mdi-view-dashboard"
      },
      ],
      alertsNum: 0,
      alerts: [],
      facturacion: false,
      auth: new Auth(),
      modules: oAuth.getModules(),
      items: [],
      itemsH: [],
    };
  },
  methods: {
    getdashboards(name) {
      if (name == "DAVIVIENDA") {
        this.items = [
          {
            route: "/smartchronos/dashboard4",
            title: "Recursos",
            icon: "mdi-office-building",
          },
          {
            route: "/smartchronos/dashboard5",
            title: "Otros gastos",
            icon: "mdi-clipboard-list",
          },
          // {
          //   route: "/smartchronos/dashboard6",
          //   title: "COVID - 19",
          //   icon: "mdi-virus",
          // },
          {
            route: "/smartchronos/dashboard7",
            title: "comercializadoras",
            icon: "mdi-storefront",
          },
          // {
          //   route: "/smartchronos/dashboard8",
          //   title: "resumen de oficinas",
          //   icon: "mdi-store",
          // },
          // {
          //   route: "/smartchronos/dashboard9",
          //   title: "tablero comparativo",
          //   icon: "mdi-compare-horizontal",
          // },
        ];

        this.itemsH = [
          {
            route: "/smartchronos/dashboard10",
            title: "dashboard principal",
            icon: "mdi-speedometer",
          },
          {
            route: "/smartchronos/dashboard11",
            title: "resumen por medidor",
            icon: "mdi-summit",
          },
        ];
      }
      if (name == "DOLLARCITY") {
        this.items = [
          {
            route: "/smartchronos/dashboard7",
            title: "comercializadoras",
            icon: "mdi-storefront",
          },
        ];

        this.itemsH = this.itemsH = [
          {
            route: "/smartchronos/dashboard10",
            title: "energia activa",
            icon: "mdi-speedometer",
          },
          {
            route: "/smartchronos/dashboard8",
            title: "energia reactiva",
            icon: "mdi-speedometer",
          },
          {
            route: "/smartchronos/dashboard11",
            title: "resumen por medidor EA",
            icon: "mdi-summit",
          },
          {
            route: "/smartchronos/dashboard9",
            title: "resumen por medidor ER",
            icon: "mdi-summit",
          },
        ];
      }
      if(name == "MAKRO" || name == "DEMO"){
        this.items = [];
        this.itemsH = [];
      }
      if (name == "EAAV ESP") {
        this.items = [];
        this.itemsH = this.itemsH = [
          {
            route: "/smartchronos/dashboard10",
            title: "dashboard principal",
            icon: "mdi-speedometer",
          },
          {
            route: "/smartchronos/dashboard11",
            title: "resumen por medidor",
            icon: "mdi-summit",
          },
        ];
      }
    },
    async getAlerts() {
      const { data } = await apiv1({
        url: `/alerts?project=${oAuth.getProject().id}`,
        method: "GET",
      });
      this.alerts = data.filter((val) => {
        return !val.revisado;
      });
      this.alertsNum = this.alerts.length;
    },
    getproyect: function () {
      this.facturacion = this.auth.getProject().name == "DAVIVIENDA";
    },
    invoiceTool: function () {
      const fd = new FormData();
      fd.set("token", this.auth.getToken());
      this.$awn.async(
        axios({
          method: "POST",
          url: "http://45.33.113.68:2035/login",
          data: fd,
        }),
        (res) => {
          if (res.data) {
            const { o } = res.data;
            if (o) {
              location.href = `http://45.33.113.68:2035/login/usuario:${o.username}/password:${o.identificacion}/extern:true`;
            } else {
              this.$awn.warning(
                "El usuario no existen en el software de facturación"
              );
            }
          } else {
            this.auth.logout();
            this.$router.push("/");
          }
        },
        (err) => this.$awn.alert(err.data)
      );
    },
  },
});
</script>
<style lang="sass" scoped>
#sidebar
  position: fixed
  left: 0
  top: 0
  width: 300px
  height: 100%
  border-right: 1px solid rgba(#000, .1)
</style>
